import React, { Component } from 'react';
import { connect } from 'react-redux';
import {ReactComponent as TrashIcon} from "../build/images/trashtwo.svg";
import {ReactComponent as SmsIcon} from "../build/images/smsgrain.svg";
import {ReactComponent as RefreshIcon} from "../build/images/refreshmail.svg";
import {ReactComponent as MoreIcon} from "../build/images/icons/more-mail-two.svg";
import {ReactComponent as FilterIcon} from "../build/images/icons/filtermail.svg";
import {ReactComponent as SearchIcon} from "../build/images/icons/searchmail.svg";
import {ReactComponent as ColumnFilterIcon} from "../build/images/icons/ColumnFilterIcon.svg";
import Table from "../components/table";
import _ from "lodash";
import PopoverColumnsFilter from "../components/popovercolumnsfilter/PopoverColumnsFilter";
import Drawer from "../components/mail-section/Drawer";
import '../build/css/email.css';
import { connection_platform } from '../services/api';
import axios from 'axios';
import Moment from 'moment';
import ReactHtmlParser from 'react-html-parser'

var port = localStorage.getItem('port');
var pathname = localStorage.getItem('pathname');

let columns = [];
let exhibColumn = [];

function defaultSorting(rowA, rowB, columnId) {
    const objectRowA = rowA.original[columnId].data;
    const objectRowB = rowB.original[columnId].data;

    if (objectRowA > objectRowB) return -1;
    if (objectRowB > objectRowA) return 1;
    return 0;
}

function chooseDisplay(nameDisplay) {
    const indexFind = exhibColumn.findIndex(
      (column) => column.title.toLowerCase() === nameDisplay.toLowerCase()
    );

    return exhibColumn[indexFind].exhib;
}

const mapStateToProps = (state) => {
    return {
       ColumnsMail: state.columnsmail
    };
}

 class Email extends Component {
        constructor(props) {
            super(props);
            this.state = {
                initialSorted: 'sender', 
                isVisibleDrawer: false, 
                mailDataComplete: [], 
                mailData: [], 
                textInput: ""
            };
        }

        componentDidMount() {
            this.updateMails();
        }

        async updateMails(){
            port = localStorage.getItem('port');
            pathname = localStorage.getItem('pathname');

            this.setState({mailData: [], mailDataComplete: []})
            
            const retorno = await axios.get(`${connection_platform.type_connect}://${pathname}:${port}/conn/list-mails-sent`)
        
            let array = [];
            let data = retorno.data;

            let dataRefactored = [];

            data.forEach((datum) => {
                let text = datum.message;
                // text = text.replace(/<p>/gi, "")
                text = text.replace( /(<([^>]+)>)/ig, '');
                // text = text.replace(/</p>/gi, "")

                let destinations = datum.email.split("¿")
                let ccResp = "";
                let toResp = "";
                let ccoResp = "";
                let byResp = "";
                if(destinations.length !== 0){
                    destinations.map((destination) => {
                        let emailSplit = destination.split("§");
                        if(emailSplit[1] === "2"){
                            if(ccResp === "")
                                ccResp = emailSplit[0]
                            else
                                ccResp = ccResp+','+emailSplit[0]
                        }
                        if(emailSplit[1] === "1"){
                            if(toResp === "")
                                toResp = emailSplit[0]
                            else
                                toResp = toResp+','+emailSplit[0]
                        }
                        if(emailSplit[1] === "3"){
                            if(ccoResp === "")
                                ccoResp = emailSplit[0]
                            else
                                ccoResp = ccoResp+','+emailSplit[0]
                        }
                        if(emailSplit[1] === "4"){
                            if(byResp === "")
                                byResp = emailSplit[0]
                            else
                                byResp = byResp+','+emailSplit[0]
                        }
                    })
                }
     
                const mailRefactored = {
                    actions_primary: {
                        data: "",
                        config: {
                            className: "",
                            filterValue: "",
                            customOrder: "",
                            textEllipsis: false,
                            customData: false,
                            favorite: datum.favorite,
                            read: true,
                            filter: datum.message + datum.assunto
                        },
                    },
                    sender: {
                        data: byResp,
                        config: {
                            className: "cell-blue-text",
                        },
                    },
                    recipient: {
                        data: toResp,
                        config: {
                            textEllipsis: true,
                        },
                    },
                    copy: {
                        data: ccResp,
                        config: {
                            textEllipsis: true,
                        },
                    },
                    subject: {
                        data: ReactHtmlParser(`<div class="text_subject"><b>${datum.assunto}</b> - ${text}</div>`),
                        config: {
                            textEllipsis: true,
                        },
                    },
                    actions_secondary: {
                        data: datum.email_to,
                        config: {
                            textEllipsis: true,
                        },
                    },
                    date: {
                        data: Moment(datum.datesend).format('DD/MM/YYYY HH:mm:ss'),
                        config: {
                            textEllipsis: true,
                        },
                    },
                };
                dataRefactored.push(mailRefactored);
            });
            this.setState({mailData: dataRefactored, mailDataComplete: dataRefactored})
        }

        setVisibleDrawer(bind){
            bind.setState({isVisibleDrawer: false})
        }

render(){

        const { initialSorted, isVisibleDrawer, textInput } = this.state;
        const { ColumnsMail } = this.props;

        exhibColumn = [
            {
                title: "Remetente",
                exhib: ColumnsMail.sender,
            },
            {
                title: "Destinatários",
                exhib: ColumnsMail.recipient,
            },
            {
                title: "Assunto",
                exhib: ColumnsMail.subject,
            },
            {
                title: "Data",
                exhib: ColumnsMail.date,
            },
            {
                title: "Cópia",
                exhib: ColumnsMail.copy,
            },
            {
                title: "Cópia Oculta",
                exhib: ColumnsMail.hidden_copy,
            }
        ];

        columns = [
            {
                Header: "",
                accessor: "actions_primary",
                id: "actions_primary",
                disableFilters: true,
                sortType: defaultSorting,
                display: true,
            },
            {
                Header: "Remetente",
                accessor: "sender",
                id: "sender",
                disableFilters: true,
                sortType: defaultSorting,
                display: true,
            },
            {
                Header: "Destinatários",
                accessor: "recipient",
                id: "recipient",
                sortType: defaultSorting,
                disableFilters: true,
                display: true,
            },
            {
                Header: "Cópia",
                accessor: "copy",
                id: "copy",
                sortType: defaultSorting,
                disableFilters: true,
                display: chooseDisplay('Cópia'),
            },
            {
                Header: "Cópia Oculta",
                accessor: "hidden_copy",
                id: "hidden_copy",
                sortType: defaultSorting,
                disableFilters: true,
                display: chooseDisplay('Cópia Oculta'),
            },
            {
                Header: "Assunto",
                accessor: "subject",
                id: "subject",
                sortType: defaultSorting,
                disableFilters: true,
                display: true,
            },
            {
                Header: "",
                accessor: "actions_secondary",
                id: "actions_secondary",
                disableFilters: true,
                sortType: defaultSorting,
                display: true,
            },
            {
                Header: "Data",
                accessor: "date",
                id: "date",
                sortType: defaultSorting,
                disableFilters: true,
                display: true,
            },
        ];

        const sortBy = {
            sortBy: initialSorted ? [
                {
                id: "date",
                desc: false,
                },
            ]:[]
        }

        if(textInput !== ""){
            const list = this.state.mailDataComplete;
            this.state.mailData = _.filter(list, mail => {
            let arrayMail = [
                // mail.subject,
                mail.recipient.data,
                mail.copy.data,
                mail.actions_primary.config.filter
                // mail.recipient
            ];


            return !_.isEmpty(textInput)
                ? arrayMail.toString().toLowerCase().indexOf(textInput.toString().toLowerCase()) >
                    -1
                : true;
            });
        }else{
            this.state.mailData = this.state.mailDataComplete
        }
        
        return(
            <div className="email__container">
                <div className="email__container-header">
                    <div className="email__container-header__title">
                        <span className="email__container-header__title-span">
                            Email
                        </span>
                    </div>
                    <div className="email__container-header__actions">
                        <div className="email__container-header__actions-search">
                            <input 
                                type="text" 
                                onChange={event => this.setState({textInput: event.target.value})} 
                                value={textInput}
                                className="email__container-header__actions-search__input" 
                            />
                            <div className="email__container-header__actions-search__icon">
                                <SearchIcon />
                            </div>
                        </div>
                        <button className="email__container-header__actions-filter" onClick={event => this.setState({isVisibleDrawer: true})}><FilterIcon />Filtros</button>
                    </div>
                </div>
                <div className="email__container-subheader">
                    <div className="email__container-subheader__actionsOne">
                        <ul className="email__container-subheader__list">
                            <li>
                                <input type="checkbox" id="mark_all_inputs" className="email__container-subheader__list-checkbox" />
                            </li>
                            <li onClick={event => this.updateMails(event)}>
                                <RefreshIcon />
                            </li>
                            {/* <li>
                                <TrashIcon />
                            </li> */}
                            {/* <li>
                                <SmsIcon />
                            </li>
                            <li>
                                <MoreIcon />
                            </li> */}
                        </ul>
                    </div>
                    <PopoverColumnsFilter
                        className={"filters-columns"}
                        placement="bottom-end"
                        menuData={exhibColumn}
                    >
                        <div className="email__container-subheader__actionsTwo">
                            <ColumnFilterIcon />
                            <span className="email__container-subheader__actionsTwo-span">Colunas</span>
                        </div>
                    </PopoverColumnsFilter>
                </div> 
                <div className="email__container-table">
                    <Table
                        className="table-cases"
                        data={this.state.mailData}
                        columns={columns}
                        fixedHeader
                        // fixedFirstColumn
                        // filtersActive={filtersActive}
                        // emptyState={emptyState}
                        // setEmptyState={setEmptyState}
                        initialState={sortBy}
                    />
                </div>
                <Drawer isOpen={isVisibleDrawer} setCloseDrawer={this.setVisibleDrawer} bind={this} />
            </div>
        )
    }
}

export default connect(
    mapStateToProps,
    null
  )(Email);